import { RemoteAdminData } from 'app/infrastructure/remote-data';
import { endpoints } from './endpoints';
import { CompanyReportsAdminListWire } from './types';
import { CompanyReportsSearchModel } from './types-store';

export const api = {

  loadList: async (
    model: CompanyReportsSearchModel, startIndex: number, maxResults: number
  ): Promise<CompanyReportsAdminListWire> => {

    const response = await new RemoteAdminData(endpoints.searchCompanyReports)
      .resource<Response>()
      .filter({
        ...(startIndex !== undefined && { startIndex }),
        ...(maxResults !== undefined && { maxResults })
      })
      .create(model, false);

    const json = await response.json();

    return json.data;
  },

  deleteCompanyReport: (id: number): Promise<void> => {
    return new RemoteAdminData(endpoints.deleteCompanyReportItem)
      .resource<void>()
      .withId(id)
      .httpDelete({});
  }
};
